import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import bg from 'assets/images/bg/footer-bg.png';

const footerStyles = {
    wrap: css`
        background-image: url(${bg});
        background-size: cover;
        background-repeat: no-repeat;
        padding-bottom: 60px;
    `,
    contentPolicy: css`
        display: flex;
        justify-content: center;
        align-self: center;
        align-items: center;
        margin: 0 auto;
        padding-top: 50px;
        padding-bottom: 50px;
        gap: 20px;
        p {
            color: white;
            cursor: pointer;
        }

        .line {
            width: 1.5px;
            height: 20px;
            background-color: white;
        }
    `,
    heading: css`
        text-align: center;
        color: #8b95b3;
        font-weight: 500;
        padding: 24px;
    `,
    partnerList: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        align-self: center;
        width: min(1600px, calc(100% - 40px));
        margin: 0 auto;
        margin-bottom: 50px;

        .itemFooter {
            display: flex;
            gap: 20px;
            align-items: center;

            p {
                width: 500px;
                color: white;
                font-style: italic;
                font-family: 'UTM Avo', sans-serif;
                font-weight: 300;
            }

            .loto {
                color: #f49e1d;
                cursor: pointer;
                text-decoration: none;

                &:hover {
                    color: white;
                }
            }
        }
    `,
    partnerItem: css`
        flex: 0 0 calc(100% / 9);
        max-width: calc(100% / 9);
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            width: 110px;
            object-fit: contain;
        }
    `,

    community: css`
        padding-top: 8px;
        padding-bottom: 28px;
        border-top: 1px solid #1f3a43;
        border-bottom: 1px solid #1f3a43;
    `,
    titleComunity: css`
        padding: 16px 0;
    `,
    communityList: css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
    `,
    communityItem: css`
        background: #023131;
        border-radius: 4px;
        padding: 8px 12px;
        color: ${colors.white};
        cursor: pointer;
        img {
            width: 24px;
            margin-right: 16px;
        }
        p {
            font-size: 10px;
            color: #8b95b3;
        }
        h6 {
            font-size: 14px;
            font-weight: 500;
            margin-top: 4px;
        }
    `,
    cer: css`
        text-align: center;
        padding: 16px 0;
        border-bottom: 1px solid #1f3a43;
    `,
    cerDes: css`
        color: #8b95b3;
        font-size: 14px;
        width: 70%;
        margin: 0 auto;
        text-align: center;
        font-weight: 300;
        padding: 10px 0 20px;
    `,
    lisence: css`
        text-align: center;
        color: #8b95b3;
        background: #021818;
        padding: 12px 0;
        font-size: 14px;
    `,
};

export default footerStyles;
